import { ethers } from 'ethers';
import { useCallback } from 'react';
import { useAccount } from 'wagmi';
export const useGetSigners = (l2Rpc) => {
    const { connector } = useAccount();
    const getSigners = useCallback((address) => {
        let l1RpcProvider = null;
        const l2RpcProvider = new ethers.providers.JsonRpcProvider(l2Rpc, 'any');
        if (typeof window !== 'undefined' && typeof window.ethereum !== 'undefined') {
            l1RpcProvider = new ethers.providers.Web3Provider(window?.ethereum);
            if (connector?.name?.toLocaleLowerCase() === 'trust wallet') {
                // @ts-ignore
                l1RpcProvider = new ethers.providers.Web3Provider(window?.trustWallet);
            }
            return [l1RpcProvider.getSigner(address), l2RpcProvider.getSigner(address)];
        }
        return [];
    }, [connector, l2Rpc]);
    return { getSigners };
};
